/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Sync_FailedInputs */

const vi_error_zns_sync_failed = /** @type {(inputs: Error_Zns_Sync_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đọc được chi tiết mẫu nào từ Zalo. Thử đồng bộ lại sau ít phút.`)
};

/**

* @param {Error_Zns_Sync_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_sync_failed = /** @type {((inputs?: Error_Zns_Sync_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Sync_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_sync_failed(inputs)
});